import { LocalDate } from './_shared/domain/local-date';

export const UI_DEBOUNCE_MS = 80; //50ms => reactive but high load on browser / 200ms => less reactive but less load
export const YEAR_MIN = 0;
export const YEAR_MAX = new LocalDate().getYear();
export const SERVER_API_URL = '/';
export const SCROLL_Y_URLS = ['/home'];
export const NO_TOP_BAR_URLS = ['/home'];
export const BACK_BUTTON_URLS = ['/sheet'];
